import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect } from 'react';
import { retrieveComuni } from '../../api/tcomuni';
import themeMaker, {bssMakeStyles}  from '../../lib/theming';
import __t from '../../lib/traduzioni';
import BSSAutocomplete from '../form/BSSAutocomplete';
import BSSText from '../form/BSSText';
import { Box, FormGroup } from '@mui/material'
import BSSDataContext from '../../contexts/BSSDataContext';
import useBSSLogger from '../../hooks/useBSSLogger';

const {logger} = useBSSLogger();

const showOption = (option) => `${option.nazione.iso} ${option.comune} ${option.cap}, (${option.provincia.iso})`

const CercaComune = ({name, dependsOn, methods}) => {

    const {isodefault} = useContext(BSSDataContext)
    
    let chiave = "unico";

    const classes = bssMakeStyles();



    let propsComps = {
        unico: [{
            comp: BSSAutocomplete,
            name:name,
            methods,
            label:__t("capcitta"),
            dependsOn: dependsOn,
            remoteSearch:{fn: retrieveComuni, params: []},
            ControllerProps:{rules: {required: __t("validazione.requiredField", [__t("capcitta")])}},
            AutocompleteProps:{
                renderOption: (props, option, { selected }) =>(
                    <li {...props}>
                        {showOption(option)}
                    </li>
                ),
                getOptionLabel: showOption,             
            },
            TextFieldInputProps:{classes: {root: classes.hasLeftGroup}},
        }],
        separato: [
            {
                comp: BSSText,
                name:`cap_${name}`,
                methods,
                label: __t("cap"),
                dependsOn: dependsOn,
                ControllerProps:{rules: {required: __t("validazione.requiredField", [__t("cap")])}},            
                TextFieldInputProps:{classes: {root: classes.hasRightGroup}},
            },
            {
                comp: BSSText,
                name:`comune_${name}`,
                methods,
                label: __t("citta"),
                dependsOn: dependsOn,
                ControllerProps:{rules: {required: __t("validazione.requiredField", [__t("comune")])}},            
                TextFieldInputProps:{classes: {root: classes.hasLeftGroup}},
            }
        ]
        
        
    }

    const {watch, register, unregister} = methods;

    const depvalues = watch(dependsOn);

    const nazionedep = depvalues?.[0] ?? null;

    

    const unregisterOptions = {keepError: false, keepDirty: false, keepTouched: false, keepIsValid: false, keepValue: false, keepDefaultValue: false};
    const unregisterMap = {
        unico: {
            fields: [
                `cap_${name}`,
                `comune_${name}`
            ],
            options: unregisterOptions
        },
        separato: {
            fields: [name],
            options: unregisterOptions
        }
    }
    

    if(nazionedep !== null){
        if(nazionedep.iso !== "IT"){
            chiave = "separato"; 
        }
    } 

    const {fields: umfields, options: umoptions} = unregisterMap[chiave];
    logger.debug("unregister di", umfields, register)

    useEffect(() => {
        unregister(umfields, umoptions);        
    }, [unregister, chiave])
    
    
    const CompData = propsComps[chiave];

    return (
        <>
            <FormGroup row>                

                {CompData.map((dati, i) => {
                    const {comp: Comp, ...propsComp} = dati;
                    
                    const boxW = ((chiave === "unico") ? 1 : ((i === 0) ? 1/3 : 2/3))

                    return (
                        <Box key={i} width={boxW}>
                            <Comp  {...propsComp} />
                        </Box>
                    )


                })}
            </FormGroup>
            
        </>        
    )

}

export default CercaComune;

